function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5 9.8h1.667c.46 0 .833.38.833.85s-.373.85-.833.85H20.5v1.7c0 .47-.373.85-.833.85a.842.842 0 01-.834-.85v-1.7h-1.666a.842.842 0 01-.834-.85c0-.47.373-.85.834-.85h1.666V8.1c0-.47.373-.85.834-.85.46 0 .833.38.833.85v1.7zm-3.333 9.35c0 .47-.373.85-.834.85a.842.842 0 01-.833-.85v-1.7c0-1.408-1.12-2.55-2.5-2.55H7.167c-1.381 0-2.5 1.142-2.5 2.55v1.7c0 .47-.373.85-.834.85A.842.842 0 013 19.15v-1.7c0-2.347 1.865-4.25 4.167-4.25H13c2.301 0 4.167 1.903 4.167 4.25v1.7zm-7.084-7.65c-2.3 0-4.166-1.903-4.166-4.25S7.782 3 10.083 3c2.302 0 4.167 1.903 4.167 4.25s-1.865 4.25-4.167 4.25zm0-1.7c1.381 0 2.5-1.142 2.5-2.55s-1.119-2.55-2.5-2.55c-1.38 0-2.5 1.142-2.5 2.55s1.12 2.55 2.5 2.55z"
});

var SvgUserPlus = function SvgUserPlus(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/user-plus.aee6abee.svg";
export { SvgUserPlus as ReactComponent };